import type { InjectionKey } from "vue";

export const menuListConfigKey: InjectionKey<MenuListConfig> = Symbol("menuListConfig");
export const menuListItemsContextKey: InjectionKey<MenuListItemsContext> =
  Symbol("menuListItemsContext");

interface MenuListConfig {
  selectable?: boolean;
  multiselect?: boolean;
  role?: string; // Parent container role (e.g., "menu", "listbox")
}

interface MenuListItemsContext {
  role?: string; // Container role, used to determine item role
}
